function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import axios from 'axios';
import AxiosUtils from '../../utilities/axios-utils';
import ConfigurationManager from '../configuration-manager';
import CheckUtils from '../../utilities/check-utils';
import ApiProvider from '../api-provider';

/**
 * @memberOf module:wdh-feature-b2b
 */
var ApiClientClientOrder = /*#__PURE__*/function () {
  function ApiClientClientOrder(token) {
    _classCallCheck(this, ApiClientClientOrder);
    this.token = token;
  }
  return _createClass(ApiClientClientOrder, [{
    key: "initErrorHandling",
    value: function initErrorHandling(callback) {
      this.errorHandlingCallback = callback;
    }

    /**
    * Disable configuration for a client order
    */
  }, {
    key: "disableConfiguration",
    value: function disableConfiguration(clientOrderDetails) {
      var _this = this;
      var promise = new Promise(function (resolve, reject) {
        axios.post('/api/client-orders/disable-configuration', clientOrderDetails, AxiosUtils.getConfig(ConfigurationManager.getShopServiceEndPoint(), _this.token)).then(function (response) {
          resolve(response.data);
        }).catch(function (err) {
          reject(err);
          _this.errorHandlingCallback(err.response.data);
        });
      });
      return promise;
    }

    /**
    * Force a Client Order
    */
  }, {
    key: "force",
    value: function force(side, productId, assignments, forcingVariableId, oldAssignments) {
      var _this2 = this;
      var language = ApiProvider.getLanguage();
      var promise = new Promise(function (resolve, reject) {
        var queryUrl = "".concat(productId, "/").concat(side, "?language=").concat(language);
        var body = {
          assignments: assignments,
          forcingVariableId: forcingVariableId,
          oldAssignments: oldAssignments
        };
        axios.post("/api/client-orders/force/".concat(queryUrl), body, AxiosUtils.getConfig(ConfigurationManager.getShopServiceEndPoint(), _this2.token)).then(function (response) {
          if (response.status === 200) {
            // Success
            resolve(response.data);
          } else {
            // HTTP Error
            var reason = {
              response: response,
              message: response.statusText
            };
            reject(reason);
          }
        }).catch(function (err) {
          // Connection error
          reject(err);
        });
      });
      return promise;
    }

    /**
    * Get a client order by id
    */
  }, {
    key: "get",
    value: function get(id) {
      var _this3 = this;
      var promise = new Promise(function (resolve, reject) {
        axios.get("/api/client-orders/".concat(id), AxiosUtils.getConfig(ConfigurationManager.getShopServiceEndPoint(), _this3.token)).then(function (response) {
          if (response.status === 200) {
            // Success
            resolve(response.data);
          } else {
            // HTTP Error
            var reason = {
              response: response,
              message: response.statusText
            };
            reject(reason);
          }
        }).catch(function (err) {
          // Connection error
          reject(err);
        });
      });
      return promise;
    }

    /**
     * Gets a patient order by id
     * @param {string} id
     */
  }, {
    key: "getPatientOrder",
    value: function getPatientOrder(id) {
      var _this4 = this;
      var promise = new Promise(function (resolve, reject) {
        axios.get("/api/shop/patient-orders/".concat(id), AxiosUtils.getConfig(ConfigurationManager.getUSOrdersServiceEndPoint(), _this4.token)).then(function (response) {
          if (response.status === 200) {
            // Success
            resolve(response.data);
          } else {
            // HTTP Error
            var reason = {
              response: response,
              message: response.statusText
            };
            reject(reason);
          }
        }).catch(function (err) {
          // Connection error
          reject(err);
        });
      });
      return promise;
    }

    /**
     * Deletes a patient order by id
     * @param {string} id
     */
  }, {
    key: "deletePatientOrder",
    value: function deletePatientOrder(id) {
      var _this5 = this;
      var promise = new Promise(function (resolve, reject) {
        axios.delete("/api/shop/patient-orders/".concat(id), AxiosUtils.getConfig(ConfigurationManager.getUSOrdersServiceEndPoint(), _this5.token)).then(function (response) {
          if (response.status === 200) {
            // Success
            resolve(response.data);
          } else {
            // HTTP Error
            var reason = {
              response: response,
              message: response.statusText
            };
            reject(reason);
          }
        }).catch(function (err) {
          // Connection error
          reject(err);
        });
      });
      return promise;
    }

    /**
     * Deletes all patient orders from cart
     */
  }, {
    key: "deleteAllPatientOrders",
    value: function deleteAllPatientOrders() {
      var _this6 = this;
      var promise = new Promise(function (resolve, reject) {
        axios.delete('/api/shop/patient-orders/delete-all', AxiosUtils.getConfig(ConfigurationManager.getUSOrdersServiceEndPoint(), _this6.token)).then(function (response) {
          resolve(response.data);
        }).catch(function (err) {
          reject(err);
          _this6.errorHandlingCallback(err.response.data);
        });
      });
      return promise;
    }

    /**
    * Get all client orders in the cart
    */
  }, {
    key: "getAllInCart",
    value: function getAllInCart() {
      var _this7 = this;
      var promise = new Promise(function (resolve, reject) {
        axios.get('/api/client-orders', AxiosUtils.getConfig(ConfigurationManager.getShopServiceEndPoint(), _this7.token)).then(function (response) {
          if (response.status === 200) {
            // Success
            resolve(response.data);
          } else {
            // HTTP Error
            var reason = {
              response: response,
              message: response.statusText
            };
            reject(reason);
          }
        }).catch(function (err) {
          // Connection error
          reject(err);
        });
      });
      return promise;
    }

    /**
    * Get favourites
    */
  }, {
    key: "getFavourites",
    value: function getFavourites() {
      var _this8 = this;
      var promise = new Promise(function (resolve, reject) {
        axios.get('/api/client-orders/favourites', AxiosUtils.getConfig(ConfigurationManager.getShopServiceEndPoint(), _this8.token)).then(function (response) {
          if (response.status === 200) {
            // Success
            resolve(response.data);
          } else {
            // HTTP Error
            var reason = {
              response: response,
              message: response.statusText
            };
            reject(reason);
          }
        }).catch(function (err) {
          // Connection error
          reject(err);
        });
      });
      return promise;
    }

    /**
    * Get template for a product
    */
  }, {
    key: "getTemplate",
    value: function getTemplate(productId, ageInMonths) {
      var _this9 = this;
      var language = ApiProvider.getLanguage();
      var promise = new Promise(function (resolve, reject) {
        var url = "/api/client-orders/template/".concat(productId, "?language=").concat(language);
        if (!CheckUtils.isNullOrEmptyNumber(ageInMonths)) {
          url += "&ageInMonths=".concat(ageInMonths);
        }
        axios.get(url, AxiosUtils.getConfig(ConfigurationManager.getShopServiceEndPoint(), _this9.token)).then(function (response) {
          if (response.status === 200) {
            // Success
            resolve(response.data);
          } else {
            // HTTP Error
            var reason = {
              response: response,
              message: response.statusText
            };
            reject(reason);
          }
        }).catch(function (err) {
          // Connection error
          reject(err);
        });
      });
      return promise;
    }

    /**
    * Initialize a client order
    */
  }, {
    key: "initialize",
    value: function initialize(initializeClientOrder) {
      var _this0 = this;
      var promise = new Promise(function (resolve, reject) {
        axios.post('/api/client-orders/initialize', initializeClientOrder, AxiosUtils.getConfig(ConfigurationManager.getShopServiceEndPoint(), _this0.token)).then(function (response) {
          if (response.status === 200) {
            // Success
            resolve(response.data);
          } else {
            // HTTP Error
            var reason = {
              response: response,
              message: response.statusText
            };
            reject(reason);
          }
        }).catch(function (err) {
          // Connection error
          reject(err);
        });
      });
      return promise;
    }

    /**
    * Initialize a patient order
    */
  }, {
    key: "initializePatientOrder",
    value: function initializePatientOrder(clientOrderId, medicaidType, state) {
      var _this1 = this;
      var promise = new Promise(function (resolve, reject) {
        if (clientOrderId === null) {
          reject(new Error('clientOrderId cannot be null'));
        }
        axios.post('/api/shop/patient-orders', {
          clientOrderId: clientOrderId,
          medicaidType: medicaidType,
          state: state,
          itemNumber: null,
          warranty: null
        }, AxiosUtils.getConfig(ConfigurationManager.getUSOrdersServiceEndPoint(), _this1.token)).then(function (response) {
          if (response.status === 200) {
            // Success
            resolve(response.data);
          } else {
            // HTTP Error
            var reason = {
              response: response,
              message: response.statusText
            };
            reject(reason);
          }
        }).catch(function (err) {
          // Connection error
          reject(err);
        });
      });
      return promise;
    }

    /**
    * Do a query based on assignments
    */
  }, {
    key: "query",
    value: function query(side, productId, assignments, ageInMonths) {
      var _this10 = this;
      var language = ApiProvider.getLanguage();
      var promise = new Promise(function (resolve, reject) {
        var url = "/api/client-orders/query/".concat(productId, "/").concat(side, "?language=").concat(language);
        if (!CheckUtils.isNullOrEmptyNumber(ageInMonths)) {
          url += "&ageInMonths=".concat(ageInMonths);
        }
        axios.post(url, assignments, AxiosUtils.getConfig(ConfigurationManager.getShopServiceEndPoint(), _this10.token)).then(function (response) {
          if (response.status === 200) {
            // Success
            resolve(response.data);
          } else if (response.status === 401) {
            // force user to log in.
            window.location.reload();
          } else {
            // HTTP Error
            var reason = {
              response: response,
              message: response.statusText
            };
            reject(reason);
          }
        }).catch(function (err) {
          // Connection error
          reject(err);
        });
      });
      return promise;
    }

    /**
    * Reset client order configuration
    */
  }, {
    key: "resetConfiguration",
    value: function resetConfiguration(clientOrderDetails) {
      var _this11 = this;
      var promise = new Promise(function (resolve, reject) {
        axios.post('/api/client-orders/reset-configuration', clientOrderDetails, AxiosUtils.getConfig(ConfigurationManager.getShopServiceEndPoint(), _this11.token)).then(function (response) {
          if (response.status === 200) {
            // Success
            resolve(response.data);
          } else {
            // HTTP Error
            var reason = {
              response: response,
              message: response.statusText
            };
            reject(reason);
          }
        }).catch(function (err) {
          // Connection error
          reject(err);
        });
      });
      return promise;
    }

    /**
    * Update client order
    */
  }, {
    key: "update",
    value: function update(clientOrderDetails) {
      var _this12 = this;
      var promise = new Promise(function (resolve, reject) {
        axios.post('/api/client-orders/update', clientOrderDetails, AxiosUtils.getConfig(ConfigurationManager.getShopServiceEndPoint(), _this12.token)).then(function (response) {
          if (response.status === 200) {
            // Success
            resolve(response.data);
          } else if (response.status === 401) {
            // force user to log in.
            window.location.reload();
          } else {
            // HTTP Error
            var reason = {
              response: response,
              message: response.statusText
            };
            reject(reason);
          }
        }).catch(function (err) {
          // Connection error
          reject(err);
        });
      });
      return promise;
    }

    /**
     * Updates an existing patient order
     * @param {object} patientOrderDetails
     */
  }, {
    key: "updatePatientOrder",
    value: function updatePatientOrder(patientOrderDetails) {
      var _this13 = this;
      var promise = new Promise(function (resolve, reject) {
        axios.post('/api/shop/patient-orders/update', patientOrderDetails, AxiosUtils.getConfig(ConfigurationManager.getUSOrdersServiceEndPoint(), _this13.token)).then(function (response) {
          if (response.status === 200) {
            // Success
            resolve(response.data);
          } else {
            // HTTP Error
            var reason = {
              response: response,
              message: response.statusText
            };
            reject(reason);
          }
        }).catch(function (err) {
          // Connection error
          reject(err);
        });
      });
      return promise;
    }

    /**
    * Update end user information for a client order
    */
  }, {
    key: "updateEndUserInformation",
    value: function updateEndUserInformation(information) {
      var _this14 = this;
      var promise = new Promise(function (resolve, reject) {
        axios.post('/api/client-orders/end-user-information', information, AxiosUtils.getConfig(ConfigurationManager.getShopServiceEndPoint(), _this14.token)).then(function (response) {
          if (response.status === 200) {
            // Success
            resolve(response.data);
          } else {
            // HTTP Error
            var reason = {
              response: response,
              message: response.statusText
            };
            reject(reason);
          }
        }).catch(function (err) {
          // Connection error
          reject(err);
        });
      });
      return promise;
    }

    /**
     * Updates impression images for a client order.
     * Creates the FormData object from the input files
     * @param {string} clientOrderId
     * @param {File} leftFile
     * @param {File} rightFile
     */
  }, {
    key: "updateImpressionImages",
    value: function updateImpressionImages(clientOrderId) {
      var _this15 = this;
      var leftFile = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var rightFile = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var formData = new FormData();
      formData.append('leftFile', leftFile);
      formData.append('rightFile', rightFile);
      var promise = new Promise(function (resolve, reject) {
        axios.post("/api/shop/impression-file/".concat(clientOrderId, "/patient/upload-impression"), formData, AxiosUtils.getConfig(ConfigurationManager.getUSOrdersServiceEndPoint(), _this15.token)).then(function (response) {
          if (response.status === 200) {
            // Success
            resolve(response.data);
          } else {
            // HTTP Error
            var reason = {
              response: response,
              message: response.statusText
            };
            reject(reason);
          }
        }).catch(function (err) {
          // Connection error
          reject(err);
        });
      });
      return promise;
    }

    /**
     * Deletes the left or right side impression image for a patient order
     * @param {string} patientOrderId
     * @param {string} side
     */
  }, {
    key: "deleteImpressionImage",
    value: function deleteImpressionImage(patientOrderId, side) {
      var _this16 = this;
      var promise = new Promise(function (resolve, reject) {
        axios.delete("/api/shop/impression-file/".concat(patientOrderId, "/patient/impression-files/").concat(side), AxiosUtils.getConfig(ConfigurationManager.getUSOrdersServiceEndPoint(), _this16.token)).then(function (response) {
          if (response.status === 200) {
            // Success
            resolve(response.data);
          } else {
            // HTTP Error
            var reason = {
              response: response,
              message: response.statusText
            };
            reject(reason);
          }
        }).catch(function (err) {
          // Connection error
          reject(err);
        });
      });
      return promise;
    }

    /**
     * Validates Otoscan packageID
     * @param patientOrderId
     * @param packageId
     * @returns {Promise<unknown>}
     */
  }, {
    key: "validateOtoscanImpression",
    value: function validateOtoscanImpression(patientOrderId, packageId) {
      var _this17 = this;
      return new Promise(function (resolve, reject) {
        axios.post('/api/shop/impression-file/package-data', {
          orderId: patientOrderId,
          packageId: packageId,
          orderType: 'patient'
        }, AxiosUtils.getConfig(ConfigurationManager.getUSOrdersServiceEndPoint(), _this17.token)).then(function (response) {
          if (response.status === 200) {
            resolve(response.data);
          } else {
            var reason = {
              response: response,
              message: response.statusText
            };
            reject(reason);
          }
        }).catch(function (err) {
          // connection error
          reject(err);
        });
      });
    }

    /**
     * Validates Impression on File for particular serial Number.
     * @param patientOrderId
     * @param leftSerialNumber
     * @param rightSerialNumber
     * @param orderType
     * @returns {Promise<unknown>}
     *
     * TODO replace api url with correct once new api is build.  Expected response from the api is a true/false value the same as the api response for Otoscan package validation.
     */
  }, {
    key: "validateImpressionOnFile",
    value: function validateImpressionOnFile(patientOrderId) {
      var _this18 = this;
      var leftSerialNumber = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var rightSerialNumber = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      var orderType = arguments.length > 3 ? arguments[3] : undefined;
      var payload = {
        orderId: patientOrderId,
        orderType: orderType,
        serialData: []
      };
      if (!CheckUtils.isNullOrEmptyString(leftSerialNumber)) {
        payload.serialData.push({
          serialNumber: leftSerialNumber,
          side: 'left'
        });
      }
      if (!CheckUtils.isNullOrEmptyString(rightSerialNumber)) {
        payload.serialData.push({
          serialNumber: rightSerialNumber,
          side: 'right'
        });
      }
      return new Promise(function (resolve, reject) {
        axios.post('/api/shop/impression-file/impression-on-data', payload, AxiosUtils.getConfig(ConfigurationManager.getUSOrdersServiceEndPoint(), _this18.token)).then(function (response) {
          if (response.status === 200) {
            var _response$data, _response$data2;
            response.data.leftSerialNumber = (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.blnleftSerialNumber;
            response.data.rightSerialNumber = (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.blnrightSerialNumber;
            resolve(response);
          } else {
            var reason = {
              response: response,
              message: response.statusText
            };
            reject(reason);
          }
        }).catch(function (err) {
          // connection error
          reject(err);
        });
      });
    }

    /**
     * Adds a coupon to a client order
     * @param {string} clientOrderId
     * @param {object} coupon
     * @param {string} side
     */
  }, {
    key: "addCoupon",
    value: function addCoupon(clientOrderId, coupon) {
      var _this19 = this;
      var side = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'left';
      return new Promise(function (resolve, reject) {
        axios.post("/api/shop/patient-orders/".concat(clientOrderId, "/coupon?side=").concat(side), coupon, AxiosUtils.getConfig(ConfigurationManager.getUSOrdersServiceEndPoint(), _this19.token)).then(function (response) {
          resolve(response.data);
        }).catch(function (err) {
          reject(err);
          _this19.errorHandlingCallback(err.response.data);
        });
      });
    }

    /**
     * Removes coupon from a client order
     * @param {string} clientOrderId
     * @param {string} side
     */
  }, {
    key: "deleteCoupon",
    value: function deleteCoupon(clientOrderId) {
      var _this20 = this;
      var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'left';
      return new Promise(function (resolve, reject) {
        axios.delete("/api/shop/patient-orders/".concat(clientOrderId, "/coupon?side=").concat(side), AxiosUtils.getConfig(ConfigurationManager.getUSOrdersServiceEndPoint(), _this20.token)).then(function (response) {
          resolve(response.data);
        }).catch(function (err) {
          reject(err);
          _this20.errorHandlingCallback(err.response.data);
        });
      });
    }

    /**
     * Adds a coupon to a related product for a client order
     * @param {string} clientOrderId
     * @param {string} relatedProductId
     * @param {object} coupon
     */
  }, {
    key: "addCouponRelated",
    value: function addCouponRelated(clientOrderId, relatedProductId, coupon) {
      var _this21 = this;
      return new Promise(function (resolve, reject) {
        axios.post("/api/shop/patient-orders/".concat(clientOrderId, "/coupon/related/").concat(relatedProductId), coupon, AxiosUtils.getConfig(ConfigurationManager.getUSOrdersServiceEndPoint(), _this21.token)).then(function (response) {
          resolve(response.data);
        }).catch(function (err) {
          reject(err);
          _this21.errorHandlingCallback(err.response.data);
        });
      });
    }

    /**
     * Removes coupon from a client order
     * @param {string} clientOrderId
     * @param {string} relatedProductId
     */
  }, {
    key: "deleteCouponRelated",
    value: function deleteCouponRelated(clientOrderId, relatedProductId) {
      var _this22 = this;
      return new Promise(function (resolve, reject) {
        axios.delete("/api/shop/patient-orders/".concat(clientOrderId, "/coupon/related/").concat(relatedProductId), AxiosUtils.getConfig(ConfigurationManager.getUSOrdersServiceEndPoint(), _this22.token)).then(function (response) {
          resolve(response.data);
        }).catch(function (err) {
          reject(err);
          _this22.errorHandlingCallback(err.response.data);
        });
      });
    }
  }]);
}();
export default ApiClientClientOrder;